import { render, staticRenderFns } from "./DarkBlankLayout.vue?vue&type=template&id=932bc4d2&"
import script from "./DarkBlankLayout.vue?vue&type=script&lang=js&"
export * from "./DarkBlankLayout.vue?vue&type=script&lang=js&"
import style0 from "./DarkBlankLayout.vue?vue&type=style&index=0&id=932bc4d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports